import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { withStyles } from "@material-ui/core";
import ViewFlowLibraryPage from "../FlowLibrary/ViewFlowLibraryPage";
import CreateFlowLibraryPage from "./CreateFlowLibraryPage";

class FlowLibraryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Switch>
        <Route exact path={"/flow-library"} component={ViewFlowLibraryPage} />
        <Route
          exact
          path={"/flow-library/create"}
          component={CreateFlowLibraryPage}
        />
      </Switch>
    );
  }
}

const styles = (theme) => ({});

export default withStyles(styles)(FlowLibraryPage);
